import React from 'react';
import PropTypes from 'prop-types';
import AttemptedCall from './commentTypes/attemptedCall';
import CallComment from './commentTypes/callComment';
import TextComment from './commentTypes/textComment';
import WaitCallDetails from './commentTypes/waitCallDetails';

const CommentItem = ({ id, comment, downloadAudio, loading, solid }) => {
  const { type, duration, hidden } = comment;

  if (type === 'call' && !hidden && !duration)
    return (
      <AttemptedCall
        id={id}
        comment={{ ...comment, duration: 0 }}
        solid={solid}
      />
    );
  if (type === 'call' && hidden)
    return <WaitCallDetails id={id} comment={comment} solid={solid} />;
  if (type === 'call')
    return (
      <CallComment
        id={id}
        downloadAudio={downloadAudio}
        comment={comment}
        loading={loading}
        solid={solid}
      />
    );
  return <TextComment id={id} comment={comment} solid={solid} />;
};
CommentItem.propTypes = {
  comment: PropTypes.shape().isRequired,
  id: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  downloadAudio: PropTypes.func.isRequired,
  solid: PropTypes.bool,
};

export default CommentItem;
